import axios from "src/lib/axios";

export const getLineUUID = (param) => {
  return axios.get(`/lalamove/seller/line-uuid?${param}`);
};
